$eve_input_logical_switch $eve_button
	disabled? null
	size null
	colors <= switch_colors \primary
	direction <= switch_direction \row
	align_items \center
	justify_content \flex-start
	attr *
		^
		mol_check_checked <= checked? false
		aria-checked <= aria_checked \false
		role <= aria_role \switch
		type \checkbox
	event *
		^
		click?event <=> event_click?event null
	sub /
		<= Slider $eve_surface

